/**
 * Platform detection, used only to label the meta key. `navigator.platform` is deprecated
 * but is still the most reliable signal for "is this an Apple keyboard"; we fall back to
 * `userAgent` when it is absent.
 */
export function isMac(): boolean {
  if (typeof navigator === "undefined") {
    return false;
  }
  const platform = navigator.platform || navigator.userAgent || "";
  return /mac|iphone|ipad|ipod/i.test(platform);
}

/** The display glyph for the primary modifier: ⌘ on Apple, Ctrl elsewhere. */
export function metaKeyLabel(): string {
  return isMac() ? "⌘" : "Ctrl";
}

/** True when the platform's primary modifier is held. */
export function isMetaPressed(event: KeyboardEvent | React.KeyboardEvent): boolean {
  return isMac() ? event.metaKey : event.ctrlKey;
}

/**
 * Translates a declarative shortcut (`["Meta", "k"]`) into display keys (`["⌘", "K"]`).
 */
export function formatShortcut(shortcut: readonly string[]): string[] {
  return shortcut.map((key) => {
    switch (key) {
      case "Meta":
      case "Mod":
        return metaKeyLabel();
      case "Shift":
        return "⇧";
      case "Alt":
        return isMac() ? "⌥" : "Alt";
      case "Control":
        return isMac() ? "⌃" : "Ctrl";
      case "Enter":
        return "↵";
      case "Escape":
        return "Esc";
      default:
        return key.length === 1 ? key.toUpperCase() : key;
    }
  });
}
